<script setup lang="ts">
import { type PropType, ref } from 'vue'
import type {
  ICategory,
  ICategory_Attributes
} from '@/components/content-app/interface/blog/IBlogCategory'
import Search from '@/components/blog/header/BlogSearch.vue'
import { useRoute } from 'vue-router'

const props = defineProps({
  categories: {
    type: Object as PropType<ICategory[]>,
    required: true
  }
})

const route = useRoute()
const isDark = false
const isAllBlogsActive = ref<boolean>(true)

/**
 *
 */
const setAllBlogsActive = () => {
  props.categories.forEach((i) => {
    i.attributes.active = false
  })
  isAllBlogsActive.value = true
}

/**
 *
 * @param item - category
 */
const scrollToElement = (item: ICategory_Attributes) => {
  const targetElement = document.querySelector(`#${item.url}`)

  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' })

    isAllBlogsActive.value = false
    props.categories.forEach((i) => {
      i.attributes.active = false
    })
    item.active = true
  }
}
</script>
<template>
  <div class="flex w-full items-center justify-center gap-x-14 md:relative">
    <nav class="hidden md:flex" :class="isDark ? 'dark-navbar' : 'navbar'">
      <div class="flex flex-wrap gap-6 px-5 xl:gap-9 xl:py-3" v-if="route.name === 'blog-home'">
        <a
          :class="{ active: isAllBlogsActive }"
          class="nav relative text-xs text-[#595959] xl:text-base dark:text-white"
          href="#"
          @click="setAllBlogsActive"
          >All blogs</a
        >
        <a
          class="nav relative text-xs text-[#595959] xl:text-base dark:text-white"
          v-for="item in props.categories"
          :class="{ active: item.attributes.active }"
          :key="item.attributes.url"
          :href="`#${item.attributes.url}`"
          @click.prevent="scrollToElement(item.attributes)"
          >{{ item.attributes.title }}</a
        >
      </div>
      <div class="flex flex-wrap gap-6 px-5 xl:gap-9 xl:py-3" v-else>
        <router-link class="relative text-xs text-[#595959] xl:text-base dark:text-white" to="/blog"
          >All blogs</router-link
        >
        <router-link
          v-for="item in props.categories"
          :key="item.attributes.url"
          :to="{ path: `/blog/category/${item.attributes.url}` }"
          class="relative text-xs text-[#595959] xl:text-base dark:text-white"
        >
          {{ item.attributes.title }}
        </router-link>
      </div>
    </nav>
    <Search :categories="props.categories" />
  </div>
</template>

<style scoped>
.navbar a.router-link-exact-active {
  color: black;
}
.dark-navbar a.router-link-exact-active {
  color: #e5dfe8;
}
.navbar a.router-link-exact-active::after,
.dark-navbar a.router-link-exact-active::after,
.nav.active::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #fd5200;
  border-radius: 15px;
}
</style>
